import React from "react";
import Seo from "@/components/Seo";
import HomeHero from "@/components/sections/home/HomeHero";
import HomeStages from "@/components/sections/home/HomeStages";
import HomeTools from "@/components/sections/home/HomeTools";
import HomeBeforeAfter from "@/components/sections/home/HomeBeforeAfter";
import HomeHowItWorks from "@/components/sections/home/HomeHowItWorks";
import HomeOffers from "@/components/sections/home/HomeOffers";
import HomeWhyRaki from "@/components/sections/home/HomeWhyRaki";
import HomeCalculator from "@/components/sections/home/HomeCalculator";
import HomeResults from "@/components/sections/home/HomeResults";
import HomeIndustries from "@/components/sections/home/HomeIndustries";
import HomeAudit from "@/components/sections/home/HomeAudit";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Your sales process, automated"
        description="Raki Solutions builds AI sales workflows in Singapore that reply, follow up and book meetings for you, using the tools you already have."
        path="/"
      />
      <HomeHero />
      <HomeStages />
      <HomeTools />
      <HomeBeforeAfter />
      <HomeHowItWorks />
      <HomeOffers />
      <HomeWhyRaki />
      <HomeCalculator />
      <HomeResults />
      <HomeIndustries />
      <HomeAudit />
    </main>
  );
}
